<script setup lang="ts">
import { AppMultiSelectSearchable } from '@shared/ui/selects'

import { useFilterTutors } from '../model/filter-tutors.hook'

interface FilterTutorsProps {
  label?: string
  placeholder?: string
  disabled?: boolean
  active?: boolean
  paid?: boolean
  withPaidLabel?: boolean
}

defineOptions({
  name: 'FilterTutors',
})

const props = withDefaults(defineProps<FilterTutorsProps>(), {
  label: 'Tutors',
  placeholder: 'All',
  disabled: false,
  active: false,
  paid: false,
  withPaidLabel: false,
})

const model = defineModel<number[]>({ default: () => [] })

const {
  refSelectedIds,
  tutorOptions,
  selectedTutorOptions,
  tutorHasMore,
  tutorLoading,
  onTutorSearch,
  onTutorLoadMore,
  onTutorOpen,
} = useFilterTutors({
  selectedIds: model,
  active: props.active,
  paid: props.paid,
  withPaidLabel: props.withPaidLabel,
})
</script>

<template>
  <AppMultiSelectSearchable
    v-model="refSelectedIds"
    :options="tutorOptions"
    :selected-options="selectedTutorOptions"
    :has-more="tutorHasMore"
    :loading="tutorLoading"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    clearable
    infinite
    @search="onTutorSearch"
    @load-more="onTutorLoadMore"
    @open="onTutorOpen"
  />
</template>
